import { atom } from "jotai";

export interface LoadNavigationDecision {
  /** Configuration session the decision belongs to */
  sessionId: string;
  /** `JumpToTab` sends the user to the product view (a saved configuration) */
  jumpsToProductView: boolean;
}

/**
 * Set by `JumpToTab` once it knows whether an opened configuration jumps
 * straight to the product view. Other load-time navigation (the thumbnail
 * preselection auto-advance) waits for this and yields to the jump - two
 * navigations racing on load leave the configurator with an empty step.
 */
export const loadNavigationAtom = atom<LoadNavigationDecision | null>(null);
